import { Link, Avatar, ListItemText } from '@mui/material';
import { Iconify } from '../iconify';
import ShortenCode from '../shorten-code/ShortenCode';
import { Link as NavigateLink } from 'react-router';

type OwnProps = {
  logo: string | null;
  name: string;
  subtext?: string;
  onSubtextClick?: () => void;
  dataTestId?: string;
  onRedirectToNewRoute?: string;
};

const ClientAvatar = ({
  logo,
  name,
  subtext,
  onSubtextClick,
  dataTestId,
  onRedirectToNewRoute,
}: OwnProps) => {
  return (
    <>
      <Avatar srcSet={logo || undefined} variant="rounded">
        {/* <ImageIcon fontSize="medium" /> */}
        <Iconify icon="lucide:image" />
      </Avatar>

      <ListItemText
        disableTypography
        primary={
          onRedirectToNewRoute ? (
            <NavigateLink to={onRedirectToNewRoute}>
              <ShortenCode
                styles={{
                  color: 'warning.contrastText',
                  textDecoration: 'underline',
                }}
                value={name}
                maxLength={18}
                typography="body2"
                dataTestId={dataTestId}
              />
            </NavigateLink>
          ) : (
            <ShortenCode
              styles={{
                color: 'warning.contrastText',
                textDecoration: 'underline',
              }}
              value={name}
              maxLength={18}
              typography="body2"
              dataTestId={dataTestId}
            />
          )
        }
        secondary={
          <>
            {subtext && (
              <Link
                data-test-id="sub-text-link"
                onClick={onSubtextClick ? onSubtextClick : () => {}}
                variant="body2"
                sx={(theme) => ({
                  cursor: 'pointer',
                  color: theme.palette.grey['600'],
                  textDecoration: 'underline',
                  '&:hover': { color: theme.palette.grey['700'] },
                })}
              >
                {subtext}
              </Link>
            )}
          </>
        }
      />
    </>
  );
};

export default ClientAvatar;
